import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

import { register } from "../slices/auth";
import { clearMessage } from "../slices/message";

const Register = () => {
  const [successful, setSuccessful] = useState(false);
  const { message } = useSelector((state) => state.message);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearMessage());
  }, [dispatch]);

  const initialValues = {
    username: "",
    email: "",
    password: "",
  };

  const validationSchema = Yup.object().shape({
    username: Yup.string()
      .test(
        "len",
        "Der Benutzername muss zwischen 3 und 20 Zeichen lang sein.",
        (val) => val && val.toString().length >= 3 && val.toString().length <= 20
      )
      .required("Bitte geben Sie einen Benutzernamen ein."),
    email: Yup.string()
      .email("Bitte geben Sie eine gültige E-Mail-Adresse ein.")
      .required("Bitte geben Sie Ihre E-Mail-Adresse ein."),
    password: Yup.string()
      .test(
        "len",
        "Das Passwort muss zwischen 6 und 40 Zeichen lang sein.",
        (val) => val && val.toString().length >= 6 && val.toString().length <= 40
      )
      .required("Bitte geben Sie ein Passwort ein."),
  });

  const handleRegister = (formValue) => {
    const { username, email, password } = formValue;
    setSuccessful(false);

    dispatch(register({ username, email, password }))
      .unwrap()
      .then(() => {
        setSuccessful(true);
      })
      .catch(() => {
        setSuccessful(false);
      });
  };

  return (
    <div className="myn-auth">
      <div className="myn-card myn-auth-card">
        <div className="myn-auth__head">
          <img src="/myn-logo-full.svg" alt="MYN.CLUB" />
          <h1>Kostenlos starten</h1>
          <p>Erstellen Sie Ihr Konto und nutzen Sie die Plattform für Produkte &amp; Vertrieb.</p>
        </div>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleRegister}
        >
          <Form>
            {!successful && (
              <div>
                <div className="myn-field">
                  <label className="myn-label" htmlFor="username">Benutzername</label>
                  <Field name="username" type="text" className="myn-input" autoComplete="username" />
                  <ErrorMessage name="username" component="div" className="myn-error" />
                </div>

                <div className="myn-field">
                  <label className="myn-label" htmlFor="email">E-Mail-Adresse</label>
                  <Field name="email" type="email" className="myn-input" autoComplete="email" />
                  <ErrorMessage name="email" component="div" className="myn-error" />
                </div>

                <div className="myn-field">
                  <label className="myn-label" htmlFor="password">Passwort</label>
                  <Field name="password" type="password" className="myn-input" autoComplete="new-password" />
                  <ErrorMessage name="password" component="div" className="myn-error" />
                </div>

                <button type="submit" className="myn-btn myn-btn--primary myn-btn--block">
                  Konto erstellen
                </button>
              </div>
            )}
          </Form>
        </Formik>

        {message && (
          <div
            className={successful ? "myn-alert myn-alert--success" : "myn-alert myn-alert--danger"}
            role="alert"
          >
            {message}
          </div>
        )}

        <p className="myn-auth__alt">
          Bereits registriert? <Link to="/login">Hier anmelden</Link>
        </p>
      </div>
    </div>
  );
};

export default Register;